import React from 'react';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import CouponIcon from '@/assets/icons/coupon-icon.svg?react';
import CashIcon from '@/assets/icons/cash-icon.svg?react';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

const DepositSumStatsContent = ({ transactionStats }) => {
    const translate = useTranslate();
    const cash = typeof transactionStats?.transactionsCashDepositSum === 'number' ? transactionStats.transactionsCashDepositSum : 0;
    const coupon = typeof transactionStats?.transactionsLoyaltyPointsDepositSum === 'number' ? transactionStats.transactionsLoyaltyPointsDepositSum : 0;
    const total = cash + coupon;
    const cashPercent = total > 0 ? ((cash / total) * 100).toFixed(1).replace('.', ',') : '0,0';
    const couponPercent = total > 0 ? ((coupon / total) * 100).toFixed(1).replace('.', ',') : '0,0';
    return (
        <>
            <Typography
                variant='h3'
                sx={{
                    fontWeight: 700,
                    marginBottom: '26px',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        marginBottom: '16px',
                    },
                }}
            >
                {typeof transactionStats?.transactionsCashDepositSum === 'number' && typeof transactionStats?.transactionsLoyaltyPointsDepositSum === 'number'
                    ? `${(cash + coupon).toFixed(2).replace('.', ',')} zł`
                    : '-'}
            </Typography>
            <Box sx={{ display: 'flex', gap: '30px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CashIcon />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant='caption' fontSize={11}>
                            {translate('resources.device.labels.onlyCash')}
                        </Typography>
                        <Typography variant='caption' fontSize={14} fontWeight={600}>
                            {cashPercent}%
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CouponIcon />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant='caption' fontSize={11}>
                            {translate('resources.device.labels.coupons')}
                        </Typography>
                        <Typography variant='caption' fontSize={14} fontWeight={600}>
                            {couponPercent}%
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default DepositSumStatsContent;
